(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["characters-landing"]) return;
  try {
    
(()=>{const film=document.getElementById('film');
if(!film)return;
const play=document.getElementById('play');
film.muted=true;
function reflect(){play.textContent=film.paused?play.dataset.play:play.dataset.pause;play.setAttribute('aria-label',play.textContent)}
play.addEventListener('click',()=>{if(film.paused){film.play().catch(()=>reflect())}else{film.pause()}});
film.addEventListener('play',reflect);film.addEventListener('pause',reflect);
if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){film.autoplay=true;film.play().catch(()=>reflect())}
document.addEventListener('visibilitychange',()=>{if(document.hidden)film.pause()});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodiac-landing"] && !Shopify.designMode) return;
  try {
    
const scene = document.querySelector('.zodiac-motion');
const toggle = scene?.querySelector('.motion-toggle');
toggle?.addEventListener('click', () => {
  const paused = scene.classList.toggle('is-paused');
  toggle.setAttribute('aria-pressed', String(paused));
  toggle.setAttribute('aria-label', paused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel);
  toggle.textContent = paused ? toggle.dataset.resume : toggle.dataset.pause;
});

document.querySelectorAll('.cloth-gallery').forEach(gallery => {
 gallery.querySelectorAll('[data-cloth-show]').forEach(button => button.addEventListener('click', () => {
 gallery.querySelectorAll('[data-cloth-panel]').forEach(panel => { panel.hidden = panel.dataset.clothPanel !== button.dataset.clothShow; });
 gallery.querySelectorAll('[data-cloth-show]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
 }));
});

  } catch(e) { console.error(e); }
})();
})();
